import { render, staticRenderFns } from "./reasonAction.vue?vue&type=template&id=53cc3a42&scoped=true"
import script from "./reasonAction.vue?vue&type=script&lang=js"
export * from "./reasonAction.vue?vue&type=script&lang=js"
import style0 from "./reasonAction.vue?vue&type=style&index=0&id=53cc3a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc3a42",
  null
  
)

export default component.exports